import * as React from "react"

const SvgComponent = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={683} height={4} {...props}>
        <path data-name="Rectangle 59" fill="#f72585" d="M0 0h236v4H0z" />
        <path data-name="Rectangle 60" fill="#7209b7" d="M102 0h236v4H102z" />
        <path data-name="Rectangle 61" fill="#3a0ca3" d="M253 0h236v4H253z" />
        <path data-name="Rectangle 62" fill="#4895ef" d="M345 0h236v4H345z" />
        <path data-name="Rectangle 63" fill="#b5179e" d="M102 0h236v4H102z" />
        <path data-name="Rectangle 64" fill="#480ca8" d="M204 0h236v4H204z" />
        <path data-name="Rectangle 65" fill="#4361ee" d="M345 0h236v4H345z" />
        <path data-name="Rectangle 66" fill="#560bad" d="M151 0h236v4H151z" />
        <path data-name="Rectangle 67" fill="#3f37c9" d="M296 0h236v4H296z" />
        <path data-name="Rectangle 68" fill="#4cc9f0" d="M447 0h236v4H447z" />
    </svg>
)

export default SvgComponent
